import {ObjectOf} from 'src/types/store';
import {ActionType} from 'src/actions/utils';

export type ReducerFn<Reducer, Action = ActionType<$TSFixMe>> = (
  state: Reducer,
  action: Action
) => Reducer;

export type ReducerMap<Type> = ObjectOf<ReducerFn<Type>>;

export function createReducer<Type>(map: ReducerMap<Type>, initialState: Type) {
  return (state: Type = initialState, action: ActionType<unknown>): Type => {
    if (map[action.type]) {
      return map[action.type](state, action);
    }

    return {...state};
  };
}
